import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useLoad } from "@/lib/hooks";
import { PageHeader } from "@/components/common";
import { PageSearch } from "@/components/PageSearch";
import Overview from "./Overview";
import Coa from "./Coa";
import Receivables from "./Receivables";
import Payables from "./Payables";
import Expenses from "./Expenses";
import Banking from "./Banking";
import TaxReports from "./TaxReports";
import Journals from "./Journals";

const TABS = [["overview", "Overview", Overview], ["coa", "Chart of accounts", Coa], ["ar", "Receivables", Receivables], ["ap", "Payables", Payables],
  ["expenses", "Expenses", Expenses], ["banking", "Banking", Banking], ["tax", "Tax reports", TaxReports], ["journals", "Journals", Journals]];

export default function Accounting() {
  const [lk, reloadLk] = useLoad("/acct/lookups");
  if (!lk) return null;
  return (
    <>
      <Tabs defaultValue="overview" className="space-y-6">
        <div className="po-card space-y-4 p-5" data-testid="acct-header-block">
          <PageHeader title="Accounting" subtitle="General ledger, receivables, payables, expenses, banking and tax for this workspace."><PageSearch testId="accounting-search" placeholder="Search number, party or account" /></PageHeader>
          <TabsList className="po-segmented h-auto justify-start">{TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`acct-tab-${k}`} className="po-segment data-[state=active]:shadow-none">{l}</TabsTrigger>)}</TabsList>
        </div>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-0 space-y-6"><C lk={lk} reloadLk={reloadLk} /></TabsContent>)}
      </Tabs>
    </>
  );
}
